"use strict";
/**
 * Enumeration of possible twilio error types.
 * full definitions can be found here:
 * https://www.twilio.com/docs/video/build-js-video-application-recommendations-and-best-practices#handling-errors
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwilioErrorType = void 0;
var TwilioErrorType;
(function (TwilioErrorType) {
    TwilioErrorType["NONE"] = "none";
    TwilioErrorType["MEDIA"] = "media";
    TwilioErrorType["AUDIO"] = "audio";
    TwilioErrorType["VIDEO"] = "video";
    TwilioErrorType["CONNECT"] = "connect";
    TwilioErrorType["DISCONNECT"] = "disconnect";
    TwilioErrorType["REMOTE"] = "remote";
})(TwilioErrorType || (exports.TwilioErrorType = TwilioErrorType = {}));
//# sourceMappingURL=TwilioError.js.map